<!-- Issue row container - clickable with navigation to issue details -->
<div class="clickable flex w-full text-[14px] leading-[24px] cursor-pointer"
  [class.bg-[#EBF5FF]]="isSelected()"
  [class.bg-white]="!isSelected()"
  [class.hover:bg-gray-50]="!isSelected()"
  [nxNewTabNavigation]="['./issues/issue', issue()?.id]"
  [queryParams]="{ type: 'issue', show: issue()?.id }">
  
  <!-- Left section: Color indicator bar -->
  <div class="flex items-start">
    <div class="w-[5px] h-full" [ngStyle]="{ 'background-color': issue()?.issueType?.color }"></div>
  </div>

  <!-- Main content -->
  <div class="flex-1 flex flex-col px-2 py-1 mr-3">

    <!-- Row 1: Title and Status -->
    <div class="grid grid-cols-[1fr_auto] leading-[1.325rem]">
      <!-- Left: Title with icon and due date -->
      <div class="min-w-0">
        <div class="mr-1 float-left w-[18px] h-[18px] mt-[1px]">
          <app-issue-type-icon [issueType]="issue()?.issueType"></app-issue-type-icon>
        </div>
        @if (issue()?.dueDateTime) {
          <span class="mr-1">
            <span class="bg-[#EBEEEF] text-black whitespace-nowrap px-2 py-[2px] rounded-md text-[14px] left-0 top-[-2px]">{{issue()?.dueDateTime | date:'EEE, dd.MM.yyyy'}}</span>
          </span>
        }
        {{issue()?.title}}
      </div>

      <!-- Right: Binary status, assignee, files, comments, status -->
      <div class="flex items-center justify-end whitespace-nowrap">
        @if (showBinaryStatus()) {
          <p-tag 
            class="mr-2"
            [value]="issue()?.issueStatus?.statusGroup?.binaryStatusLabel"
            [severity]="issue()?.issueStatus?.statusGroup?.isOpen ? 'success' : 'info'">
          </p-tag>
        }
        @if (issue()?.location) {
          <span class="text-[#848488] truncate" [class.mr-2]="!issue()?.assignee">{{issue()?.location?.name}}</span>
        }
        @if (issue()?.location && issue()?.assignee) {
          <span class="text-[#848488]">&nbsp;·&nbsp;</span>
        }
        @if (issue()?.assignee) {
          <span class="mr-2 text-[#848488] truncate">{{issue()?.assignee?.displayName}}</span>
        }
        <app-files-icon class="mr-1" [count]="issue()?.fileCount" />
        <app-comments-icon class="mr-1" [count]="issue()?.noteCount" />
        <app-issue-status-icon [issueStatus]="issue()?.issueStatus"></app-issue-status-icon>
        <span class="ml-1">{{issue()?.issueStatus?.label}}</span>
      </div>
    </div>

    <!-- Row 2: Additional info / Dynamic fields -->
    @if (showAdditionalInfoRow()) {
      <div class="leading-[1.325rem]">
        <span class="text-[#848488]">
          @for (fieldName of visibleFields(); track fieldName; let isLast = $last) {
            <ng-container [ngTemplateOutlet]="getFieldTemplate(fieldName)" 
                          [ngTemplateOutletContext]="{ issue: issue() }">
            </ng-container>
            @if (!isLast) {
              <span> · </span>
            }
          }
        </span>
      </div>
    }

    <!-- Row 3: Metadata - Creator and Last Modified -->
    <div class="flex justify-between leading-[1.325rem] text-[#848488]">
      <!-- Left: Issue number, creator, creation date -->
      <div>
        {{issue()?.getPrefixedNumber()}} · Erstellt von <app-user-name [user]="issue()?.createdBy" />&nbsp;<app-relative-time [timestamp]="issue()?.createdDateTime" />
      </div>

      <!-- Right: Last modified timestamp -->
      <div class="text-right whitespace-nowrap">
        zuletzt bearbeitet <app-relative-time [timestamp]="issue()?.lastModifiedDateTime" />
      </div>
    </div>

    <!-- Row 4: Labels -->
    @if (showLabelsRow()) {
    <div class="leading-[1.325rem]">
      @for (label of issue()?.labels; track label) {
        <app-label [label]="label" class="mr-1 mb-1"></app-label>
      }
    </div>
    }

  </div>
</div>

<!-- Field Templates -->
<ng-template #orderTpl let-issue="issue">
  <a [routerLink]="['/orders/order/' + order()?.id]" class="jump">
    <span class="hover:underline cursor-pointer">{{order()?.number}}</span>
  </a>
</ng-template>

<ng-template #contactTpl let-issue="issue">
  <a [routerLink]="['/contacts/contact/' + contact()?.id]" class="jump">
    <span class="hover:underline cursor-pointer">{{contact()?.text}}</span>
  </a>
</ng-template>

<ng-template #resourcesTpl let-issue="issue">
  @if (resources() && resources()!.length > 0) {
    @for (resource of resources(); track resource.id; let isLast = $last) {
      <a [routerLink]="['/resources/resource/' + resource.id]" class="jump">
        <span class="hover:underline cursor-pointer">{{ resource.text }}</span>
      </a>@if (!isLast) {, }
    }
  }
</ng-template>